import { UseInputReturn } from './types';

export type GetInputStateTypeProps = Partial<
  UseInputReturn & { stateType: string }
>;
export type GetInputStateType = (props: GetInputStateTypeProps) => string;
export const getInputStateType: GetInputStateType = ({
  disabled,
  focus,
  invalid,
  stateType,
}) => {
  let type = 'default';
  if (disabled) {
    type = 'disabled';
  } else if (invalid) {
    type = 'invalid';
  } else if (focus) {
    type = 'focus';
  }
  return type;
};
